import React from "react";
import PropTypes from "prop-types";
import Datasheet from "react-datasheet";
// import { Range } from "immutable";
import { STATE_STATUS } from "constants/index";
// import { Button } from "antd";
import { Dropdown, Icon, Button, Row, Col } from "antd";
import StatementGeneratorForm from "forms/statement-generator-form";
// import { STATE_STATUS } from "constants/state-status";
import "styles/data-sheet.css";
import TableColumnSelector from "./../../components/table/table-column-selector";
import { BANK_STATEMENT_COLS } from "constants";
// import { StatementRecord } from "records/index";
import { Map } from "immutable";

const TableFilterButton = (
    <Button type="default" style={{ padding: "0px 5px" }}>
        Select Balance Columns
        <Icon type={"switcher"} style={{ fontSize: "22px" }} />
    </Button>
);

const TableColumnSelectorDropdown = ({
    columns,
    checkedColumns,
    onSelect,
    showAddNewFieldBtn,
    addNewField,
    hideColumnSelector
}) => (
    !hideColumnSelector? 
        <Dropdown
            trigger={["click"]}
            dropdownMa
            overlay={
                <TableColumnSelector
                    {...{
                        columns,
                        checkedColumns,
                        onSelect,
                        showAddNewFieldBtn,
                        addNewField
                    }}
                />
            }
        >
            {TableFilterButton}
        </Dropdown>
        : null
);

TableColumnSelectorDropdown.propTypes = {
    columns: PropTypes.object,
    checkedColumns: PropTypes.object,
    onSelect: PropTypes.func,
    addNewField: PropTypes.func,
    showAddNewFieldBtn: PropTypes.bool,
    hideColumnSelector: PropTypes.bool,
    isUserAllowedToEdit: PropTypes.bool
};

class BankAnalysisTable extends React.Component {
    constructor(props) {
        super(props);
        this.rowDataGenerator = this.rowDataGenerator.bind(this);
    }
    state = {
        data: [],
        newField: null,
        tableColumns:
            this.props.statement && this.props.statement.size
                ? this.props.statement.first().cols
                : BANK_STATEMENT_COLS.filter(_ => _.hide === false),
        statementFiltered: false,
        statements: this.props.statement || []
    };

    handleSaveValues = () => {
        const [, ...values] = this.state.data;
        let statement = this.state.statements;
        values.map(rowArray => {
            const obj = {
                balance: {}
            };
            rowArray.map(({ key, value }) => {
                if (key === "txn_month_year") {
                    obj[key] = value;
                }
                if (key.includes("balance_")) {
                    obj["balance"][key] = {
                        value: value.length > 0 ? value : "0",
                        is_active:
                            this.state.tableColumns.get(key) &&
                            this.state.tableColumns.getIn([key, "hide"]) ===
                                false
                                ? true
                                : false
                    };
                }
                if (
                    [
                        "total_inward_cheque",
                        "total_inward_cheque_bounce",
                        "total_outward_cheque",
                        "total_outward_cheque_bounce"
                    ].includes(key)
                ) {
                    obj[key] = value.length > 0 ? Number(value) : 0;
                }
                return value ? Number(value) : 0;
            });
            const { balance, ...restObj } = obj;
            statement = statement.set(
                rowArray[0].id,
                statement
                    .get(rowArray[0].id)
                    .set(
                        "balance",
                        new Map(statement.getIn([rowArray[0].id, "balance"]))
                            .map(_ => ({ ..._, is_active: false }))
                            .merge(balance)
                            .toJS()
                    )
                    .merge(restObj)
            );
        });
        this.props.update(statement);
    };

    createBlankStatement = values => this.props.create(values);
    monthWiseRowSorter = (a, b) => {
        if (a.txn_month_year.year() > b.txn_month_year.year()) {
            return 1;
        } else if (a.txn_month_year.year() < b.txn_month_year.year()) {
            return -1;
        } else {
            if (a.txn_month_year.month() > b.txn_month_year.month()) {
                return 1;
            } else if (a.txn_month_year.month() < b.txn_month_year.month()) {
                return -1;
            } else {
                return 0;
            }
        }
    };
    headersGenerator() {
        this.headers = this.state.tableColumns
            .filter(_ => _.hide === false)
            .toList()
            .map(_ => ({
                value: _.title,
                readOnly: true
            }))
            .toArray();
        return this.headers;
    }
    rowDataGenerator(_) {
        const arr = [];
        this.state.tableColumns.mapKeys(k => {
            if (k === "txn_month_year") {
                arr.push({
                    value: _[k],
                    key: k,
                    id: _.id,
                    readOnly: true
                });
                return;
            }
            if (
                k.includes("balance_") &&
                this.state.tableColumns.getIn([k, "hide"]) === false
            ) {
                arr.push({
                    value: (_.balance[k] && _.balance[k].value) || "0",
                    key: k,
                    id: k,
                    readOnly: !this.props.editable
                });
                return;
            } else if (!k.includes("balance_")) {
                arr.push({
                    value: String(_[k]),
                    className:
                        _[k] && _[k].length > 0 && isNaN(Number(_[k]))
                            ? "error-cell"
                            : null,
                    id: _.id,
                    key: k,
                    readOnly: !this.props.editable
                });
            }
        });
        return arr;
    }
    generateStatementSpreadsheet() {
        if (
            this.props.statement &&
            this.props.statement.size > 0 &&
            this.state.data.length === 0
        ) {
            this.setState({
                data: [
                    this.headersGenerator(),
                    ...this.props.statement
                        .toList()
                        .sort(this.monthWiseRowSorter)
                        .map(this.rowDataGenerator)
                        .toArray()
                ]
            });
        }
    }

    componentDidMount() {
        this.setState({
            statements: this.props.statement || [],
            tableColumns:
                this.props.statement && this.props.statement.size
                    ? this.props.statement.first().cols
                    : BANK_STATEMENT_COLS.filter(_ => _.hide === false)
        });
        this.generateStatementSpreadsheet();
        this.props.proxy.attach("analysis-save-handler", this.handleSaveValues);
    }
    componentDidUpdate() {
        if (
            this.props.statement &&
            this.props.statement.size &&
            !this.state.statementFiltered
        ) {
            this.setState(
                {
                    statements: this.props.statement || [],
                    tableColumns: this.props.statement
                        ? this.props.statement.first().cols
                        : BANK_STATEMENT_COLS.filter(_ => _.hide === false),
                    statementFiltered: true
                },
                () =>
                    this.setState({
                        data: [
                            this.headersGenerator(),
                            ...this.props.statement
                                .toList()
                                .sort(this.monthWiseRowSorter)
                                .map(this.rowDataGenerator)
                                .toArray()
                        ]
                    })
            );
        }
        this.generateStatementSpreadsheet();
    }

    onSelectColumns = val => {
        this.setState(
            {
                tableColumns: this.state.statements
                    ? this.state.statements.first().cols.map(_ => {
                        if (val.includes(_.dataIndex)) {
                            _.hide = false;
                            return _;
                        }
                        _.hide = true;
                        return _;
                    })
                    : this.props.statement && this.props.statement.size
                        ? this.props.statement.first().cols.map(_ => {
                            if (val.includes(_.dataIndex)) {
                                _.hide = false;
                                return _;
                            }
                            _.hide = true;
                            return _;
                        })
                        : BANK_STATEMENT_COLS.map(_ => {
                            if (val.includes(_.dataIndex)) {
                                _.hide = false;
                                return _;
                            }
                            _.hide = true;
                            return _;
                        }),
                statements: this.state.statements.map(_ => {
                    let deselctedKeys = Object.keys(_.balance).filter(
                        __ => !val.includes(__)
                    );
                    deselctedKeys.forEach(
                        __ => (_.balance[__].is_active = false)
                    );
                    return _;
                })
            },
            () => {
                this.setState({
                    data: [
                        this.headersGenerator(),
                        ...this.state.statements
                            .toList()
                            .sort(this.monthWiseRowSorter)
                            .map(this.rowDataGenerator)
                            .toArray()
                    ]
                });
            }
        );
    };

    componentWillUnmount() {
        this.props.proxy.detach("analysis-save-handler");
    }

    onCellsChange = changes => {
        let error = false;
        const grid = this.state.data.map(row => [...row]);
        changes.forEach(({ row, col, value }) => {
            if (
                value &&
                value.length > 0 &&
                isNaN(Number(value)) 
                // &&
                // (grid[row][col].key === "total_inward_cheque_bounce" ||
                //     grid[row][col].key === "total_outward_cheque_bounce") &&
                // Number(value) > Number(grid[row][col - 2].value)
            ) {
                error = true;
                grid[row][col] = {
                    ...grid[row][col],
                    value,
                    className: "error-cell"
                };
                return;
            }
            if (value && value.length > 0 && isNaN(Number(value))) {
                error = true;
            }
            grid[row][col] = {
                ...grid[row][col],
                value,
                className: error ? "error-cell" : null
            };
        });
        if (!error) {
            this.props.proxy.activate("analysis-save-handler");
        }

        this.setState({ data: grid });
    };
    renderCreateStatementForm() {
        if (
            this.props.isCreateStatement &&
            this.props.isUserAllowedToEdit &&
            this.props.status === STATE_STATUS.FETCHED &&
            (!this.props.statement || this.props.statement.size === 0)
        ) {
            return (
                <div className={"d-flex justify-content-center p-10"}>
                    <StatementGeneratorForm
                        onFormSubmit={this.createBlankStatement}
                    />
                </div>
            );
        }
    }

    addNewField = newFieldName => {
        let newColumns = this.state.tableColumns.find(
            _ => newFieldName === _.dataIndex
        );
        if (newColumns && newColumns.dataIndex) {
            return;
        }
        const newFieldMap = {
            value: "0",
            is_active: true
        };
        let newCols = this.state.statements
            ? this.state.statements.first()
            : this.props.statement.first();
        newCols = newCols.setIn(["balance", newFieldName], newFieldMap).cols;
        this.setState(
            {
                statements: this.state.statements.map(_ =>
                    _.setIn(["balance", newFieldName], newFieldMap)
                ),
                tableColumns: newCols
            },
            () => {
                this.setState({
                    data: [
                        this.headersGenerator(),
                        ...this.state.statements
                            .toList()
                            .sort(this.monthWiseRowSorter)
                            .map(this.rowDataGenerator)
                            .toArray()
                    ]
                });
            }
        );
    };

    render() {
        if (this.props.changeTableRows) {
            this.props.changeRowNumber;
            return (
                <div className={"d-flex justify-content-center p-10"}>
                    <StatementGeneratorForm
                        onFormSubmit={this.createBlankStatement}
                    />
                </div>
            );
        }

        return (
            <React.Fragment>
                {this.renderCreateStatementForm()}
                <Row>
                    {this.props.statement && this.props.statement.size ? <Col span={8}>
                        <TableColumnSelectorDropdown
                            columns={
                                this.state.tableColumns ||
                                (this.props.statement &&
                                    this.props.statement.size &&
                                    this.props.statement.first().cols) ||
                                BANK_STATEMENT_COLS
                            }
                            checkedColumns={this.state.tableColumns.filter(
                                _ => _.hide === false
                            )}
                            onSelect={this.onSelectColumns}
                            showAddNewFieldBtn={true}
                            addNewField={this.addNewField}
                            isUserAllowedToEdit={this.props.isUserAllowedToEdit}
                            hideColumnSelector={this.props.hideColumnSelector}
                        />
                    </Col> : null}
                </Row>
                <div className={"spreadsheet-table"}>
                    <Datasheet
                        valueRenderer={cell =>
                            cell.value && cell.value._isAMomentObject
                                ? `${cell.value.format("MMM-YYYY")}(${cell.id})`
                                : isNaN(cell.value)
                                    ? cell.value
                                    : Number(cell.value)
                        }
                        data={this.state.data}
                        onCellsChanged={this.onCellsChange}
                    />
                </div>
            </React.Fragment>
        );
    }
}

BankAnalysisTable.propTypes = {
    update: PropTypes.func,
    create: PropTypes.func,
    statement: PropTypes.object,
    editable: PropTypes.bool,
    status: PropTypes.string,
    type: PropTypes.string,
    proxy: PropTypes.object,
    changeTableRows: PropTypes.bool,
    changeRowNumber: PropTypes.func,
    columns: PropTypes.object,
    isCreateStatement: PropTypes.bool,
    hideColumnSelector: PropTypes.bool,
    isRiskApprover: PropTypes.bool,
    isUserAllowedToEdit: PropTypes.bool
};

BankAnalysisTable.defaultProps = {
    hideColumnSelector: false
};

export default BankAnalysisTable;
